export const CGE_POSITIVE_COLOR = '#50cd89'
export const CGE_NEGATIVE_COLOR = '#f1416c'

export function divergingColor(value: number): string {
  return value >= 0 ? CGE_POSITIVE_COLOR : CGE_NEGATIVE_COLOR
}
